export const VERSION = {
    hash: 'PLACEHOLDER',
};
